/*
@author: Nikhil 


jvActionsDropdown
============
@desc: Used to show a actionsDropdown
Usage:
    html: 
        <a jv-actions-dropdown="actionsDropDownConfig" class=" actionsDropdown"><i class="icon-expand icon action-expand"></i><span class="left">Actions<span></a>
 */

angular.module('jv.Common.Directives.Dropdown', [])

.directive('jvDropdown', function($compile){
    return {
        scope:{
            showDropdown: '&',
            hideDropdown: '&',
            triggerOnHover: '='
        },
        link: function($scope, iElm, iAttrs){
            var element = iElm[0];
            //bind a on hover event trigger in case property is set 
            if($scope.triggerOnHover){
                $(element).on('hover',function(event){
                    $scope.showDropdown();
                    $scope.$apply();
                });
            }
            //bind a click event no the document to listen for clicks on the target element
            $(document).on('click', function(event) {
                var target = (event.target);
                if(!element.contains(target) ){
                    $scope.hideDropdown();
                    $scope.$apply();
                }
                if(target === element){
                    $scope.showDropdown();
                    $scope.$apply();
                }
            });
        }
    };
});
